export enum UserRoleType {
  EDUCATION_MANAGER = 0,
  CENTRAL_MANAGER = 1,
  BRANCH_MANAGER = 2,
  USER = 3,
  INSTRUCTOR = 4,
  INTERN = 5,
  EDUCATION_SUPERVISOR = 6,
  INTERN_SUPERVISOR = 7,
}

export interface Role {
  id: string;
  roleName: string;
  roleDescription: string;
  type?: number;
  isDefault?: boolean;
  permissionKeys?: string;
  assignedPersonCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface RoleFilters {
  search?: string;
  roleName?: string;
  roleType?: number;
  /** API: sortBy - createdAt | name */
  sortBy?: "createdAt" | "name";
  /** API: sortOrder - asc | desc */
  sortOrder?: "asc" | "desc";
}
